import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 55px;
  background: #ffff;
  border-radius: 8px;
  padding: 12px;
`;

export const StepsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActivesStepsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StepCompleted = styled.div`
  width: 20px;
  height: 20px;
  background: #0b29fb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StepActive = styled.div`
  width: 20px;
  height: 20px;
  background: rgba(73, 90, 255, 0.1);
  border-radius: 50%;
  border: 0.5px solid #0b29fb;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StepActiveIcon = styled.div`
  width: 10px;
  height: 10px;
  background: #0b29fb;
  border-radius: 50%;
`;

export const StepIncomplete = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #d9d9d9;
`;

export const TitleStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #0b29fb;
`;

export const SubTitle = styled.span`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
`;

export const InconpleteStepWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
